import React from 'react'

const LoadingScreen = () => {
    return (
        <div style={{width:window.innerWidth,height:window.innerHeight,display:'flex',alignItems:'center',justifyContent:'center',backgroundColor:"#0a192f"}}>
            <img
                src={"./images/finalLogo.gif"}
                style={{width:'35vh',height:'35vh'}}
            />
        </div>
    )
}

export default LoadingScreen
